import api from "./api";

const LandingPageAPI = {
    getTermCondition: (id) => api.get(`/landing-page/term-condition/${id}`),
};

export default LandingPageAPI;